import { Modal, TextInput, Textarea, Button, Group, PasswordInput } from '@mantine/core';
import { useAdminStore } from '@/store/admin';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface CompanyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (formData: any) => void;
}

export default function CompanyModal({ isOpen, onClose, onSubmit }: CompanyModalProps) {
  const { companyName, companyDescription, companySetting } = useAdminStore((state) => state);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    initialPassword: companySetting?.initialPassword || '',
  });
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen && companyName) {
      setFormData((prev) => ({
        ...prev,
        name: companyName,
        description: companyDescription || '',
      }));
    }
  }, [isOpen, companyName, companyDescription]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    // 如果是密码字段，过滤掉汉字
    if (name === 'initialPassword') {
      const filteredValue = value.replace(/[\u4e00-\u9fa5]/g, '');
      setFormData((prev) => ({
        ...prev,
        [name]: filteredValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.initialPassword.length < 6) {
      alert(t('adminConsole.employees.passwordTooShort'));
      return;
    }
    onSubmit(formData);
  };

  return (
    <Modal opened={isOpen} onClose={onClose} title={t('adminConsole.companyModal.title')} centered>
      <form onSubmit={handleSubmit}>
        <TextInput
          label={t('adminConsole.companyModal.name')}
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          maxLength={100}
        />
        <Textarea
          label={t('adminConsole.companyModal.description')}
          name="description"
          value={formData.description}
          onChange={handleChange}
          minRows={3}
          maxLength={200}
        />
        <PasswordInput
          label={t('adminConsole.memberModal.initialPassword')}
          name="initialPassword"
          value={formData.initialPassword}
          onChange={handleChange}
          required
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button variant="outline" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button type="submit" className="ml-2">
            {t('common.saveChanges')}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
